"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAccount = void 0;
const tools_1 = require("@axiom-crypto/tools");
const utils_1 = require("../utils");
const utils_2 = require("../utils");
const data_1 = require("./data");
;
const buildAccount = (blockNumber, address) => {
    const getSubquery = (fieldIdx) => {
        let accountSubquery = {
            blockNumber: blockNumber.number(),
            addr: address.address(),
            fieldIdx: fieldIdx.number()
        };
        const dataSubquery = { subqueryData: accountSubquery, type: tools_1.DataSubqueryType.Account };
        return (0, data_1.prepData)(dataSubquery, [blockNumber, address, fieldIdx]);
    };
    const functions = Object.fromEntries(Object.keys(tools_1.AccountField).map((key) => {
        return [(0, utils_1.lowercase)(key), () => {
                const accountField = (0, utils_2.getCircuitValueConstant)(tools_1.AccountField[key]);
                return getSubquery(accountField);
            }];
    }));
    return Object.freeze(functions);
};
exports.buildAccount = buildAccount;
//# sourceMappingURL=account.js.map